import React, { useEffect, useState } from 'react';
import { useDisclosure } from '@chakra-ui/react';

import PageContainer from 'Components/Atoms/PageContainer';
import WithDrawer from 'Components/Templates/WithDrawer';
import VendorsForm from 'Components/Organisms/VendorsForm';
import VendorsTable from 'Components/Organisms/VendorsTable';

const Vendors: React.FC = () => {
  useEffect(() => {
    document.title = 'Vendors - Orion';
  }, []);

  const { isOpen, onOpen, onClose } = useDisclosure();

  const [loadingTable, setLoadingTable] = useState(true);

  return (
    <WithDrawer>
      <PageContainer>
        <VendorsForm
          isOpen={isOpen}
          onOpen={onOpen}
          onClose={onClose}
          setLoadingTable={setLoadingTable}
        />
        <VendorsTable
          onOpenForm={onOpen}
          loadingTable={loadingTable}
          setLoadingTable={setLoadingTable}
        />
      </PageContainer>
    </WithDrawer>
  );
};

export default Vendors;
